<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container class="d-flex justify-start pa-0">
        <v-btn color="primary" outlined @click="openPanelDialog('add')">
          <span>{{ $t("add-new-panel") }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
      </v-container>
      <v-container class="pa-0 mt-5 columns">
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">{{ item.panel_name }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-3">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{ color: item.panel_status == 'active' ? '#137333' : '#ff5252' }"
            >
              {{ $t(item.panel_status) }}
            </v-card-text>
            <v-btn
              outlined
              color="primary"
              height="32"
              @click="openSyncPermission(item, index)"
              :disabled="syncingPanels.includes(index)"
            >
              {{
                syncingPanels.includes(index)
                  ? $t("synchronizing-products") + "..."
                  : $t("synchronize-products")
              }}
            </v-btn>
            <v-btn
              color="primary"
              outlined
              height="32"
              @click="copyToClipboard(item.panel_token)"
              :disabled="item.panel_token == null"
            >
              {{ $t("orderWebhook") }}
            </v-btn>
            <div @click="openPanelDialog('edit', item)">
              <my-icon
                :name="'edit-icon'"
                :width="16"
                :height="17"
                :stroke="'#000'"
                :cursor-pointer="true"
              />
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn color="primary" height="32" @click="submit" :loading="loading">
            {{ $t("submit") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="firstStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedPanel ? selectedPanel.panel_name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-cente gap-2">
            <v-text-field
              v-model="newPanel.panel_name"
              :label="$t('panel_name')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 mx-0"
              style="width: 151px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPanel == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-btn
              color="primary"
              outlined
              height="32"
              @click="copyWebHook"
              :disabled="newPanel.panel_token == null"
            >
              {{ $t("orderWebhook") }}
            </v-btn>
          </v-container>
          <v-container class="pa-0 d-flex gap-2 mt-6">
            <v-text-field
              v-model="newPanel.additional_data.domain_address"
              :label="$t('domainName')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
              dir="ltr"
              @focus="isUserFocusOnDomain = true"
              @blur="resolveDomainPrefix"
              class="domain-input"
            >
              <template v-slot:prepend-inner>
                <v-card-text
                  :style="{ display: isUserFocusOnDomain ? 'block' : 'none' }"
                  class="text--secondary text-body-2 pa-0 mt-1"
                >
                  https://
                </v-card-text>
              </template>
            </v-text-field>
            <!-- <v-text-field
              v-model="newPanel.domain_address"
              :label="$t('domainName')"
              outlined
              height="32"
              dense
              style="width: 0;"
              :rules="[v => !!v || $t('is-required')]"
            /> -->
            <v-text-field
              v-if="newPanel && newPanel.additional_data"
              v-model="newPanel.additional_data.portal_token"
              :label="$t('apiKey')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mb-9 mt-10">
            <v-text-field
              v-if="newPanel && newPanel.additional_data"
              v-model="newPanel.additional_data.currency_coefficient"
              :label="$t('currency_coefficient')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              type="number"
            />
            <!--add phone number and name user -->
            <v-text-field
              v-if="newPanel && newPanel.additional_data"
              v-model="newPanel.additional_data.contact"
              :label="$t('phone-number')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-text-field
              v-if="newPanel && newPanel.additional_data"
              v-model="newPanel.additional_data.password"
              :label="$t('password')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <!-- -->
            <div style="width: 30.5%"></div>
          </v-container>
          <v-container
            class="pa-0 d-flex gap-2 mt-6"
            v-if="dialogType === 'edit' && newPanel.panel_token"
          >
            <v-chip
              label
              dark
              color="green"
              link
              @click="copyConnectionKey"
            >
              {{ $t("connection_key") }} : {{ newPanel.panel_token }}
              <v-icon class="mx-2">mdi-content-copy</v-icon>
            </v-chip>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("invoice-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <v-select
              v-model="newPanel.additional_data.confirm_status"
              :label="$t('registerStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.additional_data.edit_status"
              :label="$t('editStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.additional_data.destroy_status"
              :label="$t('removeStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.additional_data.return_sell_status"
              :label="$t('returnSellStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn color="primary" height="32" @click="nextStep">
                {{ $t("next-step") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32" @click="panelDialog = false">
                {{ $t("cancel") }}
              </v-btn>
            </div>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="secondPanelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="secondStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedPanel ? selectedPanel.panel_name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="secondPanelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("warehouse and branch settings")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="newPanel.additional_data.default_branch"
              :title="$t('defaultBranch')"
              type="branch"
              class="flex-fill"
            />
            <autocomplete
              v-model="newPanel.additional_data.seller_warehouse"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('entrepotToUse')"
              type="entrepot"
              class="flex-fill"
            />
          </v-container>
          <v-container class="d-flex align-center gap-3 pa-0 mb-7 mt-11">
            <v-card-text class="pa-0 text-body-2">{{
              $t("inventory-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusInventoryUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{
              $t("fixed-price-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPriceUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container class="pa-0 d-flex align-center justify-space-between">
            <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
              $t("payment-method")
            }}</v-card-text>
            <v-btn color="secondary" outlined @click="addNewPaymentMethod">
              {{ $t("add-new-payment-method") }}
              <v-icon size="20" class="ms-2">mdi-plus</v-icon>
            </v-btn>
          </v-container>
          <v-data-table
            :headers="headers"
            :items="paymentMethodsItems"
            :items-per-page="-1"
            hide-default-footer
            :height="isMobile || isTablet ? 265 : 200"
            fixed-header
            class="paymentTable"
          >
            <template v-slot:item.bank="{ item, index }">
              {{ (item.bank && item.bank.name) || item.name || "" }}
            </template>
            <template v-slot:item.method="{ item, index }">
              {{ $t(item.method) }}
            </template>
            <template v-slot:header.edit="{ header }">
              <v-container
                class="pa-0 d-flex align-center justify-space-between ma-0 gap-1"
              >
                {{ $t("delete all") }}
                <div style="cursor: pointer" @click="openDeleteDialog('all')">
                  <my-icon
                    :name="'trash-icon'"
                    :width="15"
                    :height="15"
                    :cursor-pointer="true"
                  />
                </div>
              </v-container>
            </template>
            <template v-slot:item.edit="{ item, index }">
              <div
                class="d-flex justify-center"
                style="cursor: pointer"
                @click="openDeleteDialog('single', item)"
              >
                <my-icon
                  :name="'trash-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
            </template>
          </v-data-table>
          <v-container class="pa-0 d-flex justify-space-between mt-9">
            <div class="d-flex align-center gap-2">
              <v-btn color="primary" height="32" @click="checkValidation">
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="primary" height="32" outlined @click="prevStep">
                {{ $t("previus-step") }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                height="32"
                @click="secondPanelDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </div>
            <v-btn color="error" outlined height="32" @click="openDeleteDialog('panel')">
              <span class="ml-1">{{ $t("delete-panel") }}</span>
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :fill="'#ff5252'"
                :cursor-pointer="true"
              />
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="500"
    >
      <v-card class="pa-5">
        <v-form ref="thirdStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">{{
              $t("add-new-payment-method")
            }}</v-card-text>
            <v-icon size="20" @click="paymentDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="paymentMethods.bank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
              :rules="[(v) => !!v || $t('is-required')]"
              :outlined="true"
              :value="paymentMethods.bank"
            />
            <v-select
              v-model="paymentMethods.method"
              :label="$t('method')"
              :items="paymentMethodsOptions"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-12">
            <v-btn color="primary" height="32" @click="addPaymentMethod">
              {{ $t("confirm") }}
            </v-btn>
            <v-btn color="secondary" outlined height="32" @click="paymentDialog = false">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteMode == "all"
              ? $t("are you sure you want to delete all items?")
              : deleteMode == "single"
              ? $t("Are you sure you want to delete this item ?")
              : deleteMode == "panel"
              ? $t("do you want to delete this panel ?")
              : ""
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
          <v-btn color="error" height="32" @click="remove" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSyncPermission"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from portal")
          }}</v-card-text>
          <v-icon size="20" @click="productSyncPermission = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 my-8" style="line-height: 25px">
          {{ $t("do you want to sync the panel product information ?") }}
          <br />
          {{ panelName }}
          <br />
          {{ $t("are you sure ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn color="primary" height="32" @click="synchronization">
            {{ $t("yes, synchronize") }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            height="32"
            @click="productSyncPermission = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSync"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from portal")
          }}</v-card-text>
          <v-icon size="20" @click="productSync = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-5">
          <img src="@/assets/integrators/sync-sazito.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2 text-center" style="line-height: 25px">
            {{ $t("we are syncing panel product information") }}
            {{ panelName }}
            {{ $t("from sazito") }}
            {{ $t("this process may take time. Please be patient.") }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="syncSuccessDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="syncSuccessDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-7">
          <img v-if="isUserGaveAccess" src="@/assets/integrators/sync-success.png" />
          <img v-else src="@/assets/integrators/sync-failed.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2">
            {{
              isUserGaveAccess
                ? $t("your connection has been established successfully.")
                : $t(
                    "unfortunately your connection has not been established successfully."
                  )
            }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../components/general/icon/MyIcon.vue";
import General from "../../../../Mixins/general";

export default {
  data() {
    return {
      panelDialog: false,
      secondPanelDialog: false,
      paymentDialog: false,
      selectedStatusPanel: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      entrepot: null,
      items: [],
      statusItems: [
        {
          value: "pending",
          text: this.$t("Pending_confirmation"),
        },
        {
          value: "unfulfilled",
          text: this.$t("unfulfilled"),
        },
        {
          value: "processing",
          text: this.$t("processing_"),
        },
        {
          value: "fulfilled",
          text: this.$t("fulfilled"),
        },
        {
          value: "failed",
          text: this.$t("failed"),
        },
        {
          value: "canceled",
          text: this.$t("canceled"),
        },
        {
          value: "deleted",
          text: this.$t("deleted"),
        },
      ],
      userInfo: null,
      loading: false,
      newPanel: {
        id: null,
        type: "portal",
        abr_name: null,
        phone: null,
        abr_token: null,
        panel_name: null,
        panel_status: null,
        panel_token: null,
        additional_data: Object.assign(
          {},
          {
            password: null,
            contact: null,
            // bugfix: API store/list expects payments inside additional_data (not top-level)
            payments: [],
            domain_address: null,
            currency_coefficient: null,
            portal_token: null,
            default_branch: null,
            confirm_status: null,
            edit_status: null,
            destroy_status: null,
            return_sell_status: null,
            seller_warehouse: null,
            inventory_update: null,
            price_update: null,
          }
        ),
      },
      paymentMethods: {
        bank: null,
        method: null,
      },
      paymentMethodsOptions: [
        {
          value: "zibal",
          text: this.$t("zibal"),
        },
        {
          value: "zarinpal",
          text: this.$t("zarinpal"),
        },
        {
          value: "saman",
          text: this.$t("saman"),
        },
        {
          value: "mellat",
          text: this.$t("mellatpayment"),
        },
        {
          value: "pasargad",
          text: this.$t("pasargard"),
        },
        {
          value: "parsian",
          text: this.$t("parsian"),
        },
        {
          value: "digipay",
          text: this.$t("digipay"),
        },
        {
          value: "snappay",
          text: this.$t("snapp_pay"),
        },
        {
          value: "sadad",
          text: this.$t("sadad"),
        },
        {
          value: "payping",
          text: this.$t("payping"),
        },
        {
          value: "sepehr",
          text: this.$t("sepehr"),
        },
        {
          value: "irankish",
          text: this.$t("iran_kish"),
        },
        {
          value: "irankishtoken",
          text: this.$t("iran_kish_token"),
        },
        {
          value: "zarinplus",
          text: this.$t("zarinplus"),
        },
        {
          value: "torobpay",
          text: this.$t("trobpay"),
        },
      ],
      headers: [],
      paymentMethodsItems: [],
      deleteMode: null,
      newSelectedMethod: null,
      selectedPanel: null,
      isUserFocusOnDomain: false,
      productSyncPermission: false,
      panelName: null,
      productSync: null,
      selectedSyncPanel: null,
      syncingPanels: [],
      syncSuccessDialog: false,
      isUserGaveAccess: false,
      wantedSyncPanel: null,
    };
  },
  mixins: [General],
  methods: {
    copyToClipboard(text) {
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.copied();
          })
          .catch((err) => {
            console.error("Failed to copy:", err);
            this.fallbackCopyToClipboard(text);
          });
        return;
      }
      this.fallbackCopyToClipboard(text);
    },
    fallbackCopyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "0";
      textarea.style.left = "0";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const ok = document.execCommand("copy");
        if (ok) this.copied();
      } catch (err) {
        console.error("Failed to copy:", err);
      }
      document.body.removeChild(textarea);
    },
    copyConnectionKey() {
      this.copyToClipboard(this.newPanel.panel_token);
    },
    copyWebHook() {
      // const text = `https://integrator.abriron.com/api/portal/webhook?key=${}`;
      this.copyToClipboard(this.newPanel.panel_token);
    },
    fetchPanelList() {
      var app = this;
      app.$axios
        .get(this.$endpoint + "integrator/portal/list")
        .then((r) => {
          this.items = r.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPanelDialog(type, selectedItem) {
      this.panelDialog = true;
      if (type == "add") {
        this.clearForm();
        this.newPanel.additional_data.currency_coefficient = 1;
        this.dialogType = "add";
      }
      if (type == "edit" && selectedItem) {
        this.dialogType = "edit";
        this.isUserFocusOnDomain = true;
        this.selectedPanel = selectedItem;
        this.newPanel.panel_token = selectedItem.panel_token;
        // put inputs in forms
        const paymentsFromApi =
          selectedItem.additional_data?.payments ?? selectedItem.payments;
        const paymentsArr = Array.isArray(paymentsFromApi) ? paymentsFromApi.slice() : [];
        this.newPanel = {
          id: selectedItem.id,
          type: "portal",
          phone: selectedItem.phone,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: selectedItem?.panel_name ?? null,
          panel_status: selectedItem?.panel_status ?? "active",
          panel_token: selectedItem?.panel_token ?? null,
          additional_data: {
            domain_address: selectedItem?.additional_data?.domain_address ?? null,
            password: selectedItem?.additional_data?.password ?? null,
            contact: selectedItem?.additional_data?.contact ?? null,
            currency_coefficient:
              selectedItem?.additional_data?.currency_coefficient ?? 1,
            contact: selectedItem?.additional_data?.contact ?? 1,
            password: selectedItem?.additional_data?.password ?? 1,
            portal_token: selectedItem?.additional_data?.portal_token ?? null,
            default_branch: selectedItem?.additional_data?.default_branch ?? null,
            confirm_status: selectedItem?.additional_data?.confirm_status ?? null,
            edit_status: selectedItem?.additional_data?.edit_status ?? null,
            destroy_status: selectedItem?.additional_data?.destroy_status ?? null,
            return_sell_status: selectedItem?.additional_data?.return_sell_status ?? null,
            seller_warehouse: selectedItem?.additional_data?.seller_warehouse ?? null,
            inventory_update: selectedItem?.additional_data?.inventory_update ?? "active",
            price_update: selectedItem?.additional_data?.price_update ?? "active",
            payments: paymentsArr,
          },
        };
        this.selectedStatusPanel = selectedItem?.panel_status ?? "active";
        this.selectedStatusInventoryUpdate =
          selectedItem?.additional_data?.inventory_update ?? "active";
        this.selectedStatusPriceUpdate =
          selectedItem?.additional_data?.price_update ?? "active";

        // bugfix: same array ref as additional_data.payments so table edits stay in sync with submit payload
        this.paymentMethodsItems = paymentsArr;

        this.selectedIndex = this.items.findIndex(
          (item) =>
            item?.additional_data?.portal_token ==
            selectedItem?.additional_data?.portal_token
        );
      }
    },
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
      this.newPanel.panel_status = this.selectedStatusPanel;
    },
    selectStatusInventoryUpdate(item) {
      this.selectedStatusInventoryUpdate = item.value;
      this.newPanel.additional_data.inventory_update = this.selectedStatusInventoryUpdate;
    },
    selectStatusPriceUpdate(item) {
      this.selectedStatusPriceUpdate = item.value;
      this.newPanel.additional_data.price_update = this.selectedStatusPriceUpdate;
    },
    nextStep() {
      if (this.$refs.firstStep.validate()) {
        this.panelDialog = false;
        this.secondPanelDialog = true;
        if (this.dialogType == "add") {
          this.selectedStatusInventoryUpdate = "active";
          this.selectedStatusPriceUpdate = "active";
          this.newPanel.additional_data.inventory_update = this.selectedStatusInventoryUpdate;
          this.newPanel.additional_data.price_update = this.selectedStatusPriceUpdate;
        }
      }
    },
    prevStep() {
      this.secondPanelDialog = false;
      this.panelDialog = true;
    },
    checkValidation() {
      if (this.$refs.secondStep.validate() && this.dialogType == "add") {
        this.addPanel();
      }
      if (this.$refs.secondStep.validate() && this.dialogType == "edit") {
        this.editPanel();
      }
    },
    addPanel() {
      const sameObject = this.items.some(
        (item) =>
          item.additional_data.portal_token == this.newPanel.additional_data.portal_token
      );
      if (!sameObject) {
        // add columns (show)
        this.items.push(this.newPanel);
        this.secondPanelDialog = false;
      } else {
        this.snakbarText = this.$t("duplicate digikala token");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    editPanel() {
      // edit column (show)
      this.items.splice(this.selectedIndex, 1, this.newPanel);
      this.secondPanelDialog = false;
    },
    clearForm() {
      this.newPanel = {
        id: null,
        type: "portal",
        phone: null,
        abr_name: this.userInfo?.init?.abrName,
        abr_token: this.userInfo?.token,
        panel_name: null,
        panel_status: "active",
        panel_token: null,
        additional_data: Object.assign(
          {},
          {
            password: null,
            contact: null,
            payments: [],
            domain_address: null,
            currency_coefficient: 1,
            portal_token: null,
            default_branch: null,
            confirm_status: null,
            edit_status: null,
            destroy_status: null,
            return_sell_status: null,
            seller_warehouse: null,
            inventory_update: "active",
            price_update: "active",
          }
        ),
      };
      // reset toggle button
      this.selectedStatusPanel = "active";
      this.selectedStatusInventoryUpdate = "active";
      this.selectedStatusPriceUpdate = "active";

      this.newPanel.panel_status = this.selectedStatusPanel;
      this.newPanel.additional_data.inventory_update = this.selectedStatusInventoryUpdate;
      this.newPanel.additional_data.price_update = this.selectedStatusPriceUpdate;

      // reset form
      if (this.$refs.firstStep && this.$refs.secondStep && this.$refs.thirdStep) {
        this.$refs.firstStep.reset();
        this.$refs.secondStep.reset();
        this.$refs.thirdStep.reset();
      }

      // bugfix: one shared array for table + payload (avoid undefined push / drift)
      const emptyPayments = [];
      this.newPanel.additional_data.payments = emptyPayments;
      this.paymentMethodsItems = emptyPayments;
    },
    addNewPaymentMethod() {
      this.paymentDialog = true;
    },
    addPaymentMethod() {
      if (!Array.isArray(this.paymentMethodsItems)) {
        this.paymentMethodsItems = [];
      }
      if (!this.newPanel.additional_data) {
        this.newPanel.additional_data = {};
      }
      if (!Array.isArray(this.newPanel.additional_data.payments)) {
        this.newPanel.additional_data.payments = [];
      }
      // bugfix: keep table array identical to additional_data.payments (store API shape)
      if (this.paymentMethodsItems !== this.newPanel.additional_data.payments) {
        this.paymentMethodsItems = this.newPanel.additional_data.payments;
      }
      this.paymentMethodsItems.push(this.paymentMethods);

      this.newPanel.additional_data.payments = this.paymentMethodsItems;

      this.paymentDialog = false;
      this.paymentMethods = {
        bank: null,
        method: null,
      };
      // reset form
      this.$refs.thirdStep.reset();
    },
    openDeleteDialog(type, selectedMethod) {
      if (type == "all") {
        this.deleteMode = "all";
        this.deleteDialog = true;
      }
      if (type == "single" && selectedMethod != null) {
        this.deleteMode = "single";
        this.deleteDialog = true;
        this.newSelectedMethod = selectedMethod;
      }
      if (type == "panel") {
        if (this.dialogType == "add") {
          this.secondPanelDialog = false;
          this.clearForm();
        }
        if (this.dialogType == "edit") {
          this.deleteMode = "panel";
          this.deleteDialog = true;
        }
      }
    },
    submit() {
      // post api
      this.loading = true;
      const payload = this.items.map((item) => ({
        ...item,
        additional_data: {
          ...(item.additional_data || {}),
          password: item.additional_data?.password || null,
          contact: item.additional_data?.contact || null,
        },
      }));
      var app = this;
      app.$axios
        .post(this.$endpoint + "integrator/portal/store", payload)
        .then((r) => {
          this.loading = false;
          this.snakbarText = this.$t("new panel successfully added");
          this.snakbarColor = "green";
          this.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    remove() {
      if (this.deleteMode == "all") {
        // bugfix: keep payments arrays aligned with additional_data (store payload)
        const empty = [];
        this.newPanel.additional_data.payments = empty;
        this.paymentMethodsItems = empty;
        this.deleteDialog = false;
      }
      if (this.deleteMode == "single") {
        // bugfix: API rows use name; UI rows use bank.name — indexOf handles both via same-array ref
        const idx = this.paymentMethodsItems.indexOf(this.newSelectedMethod);
        if (idx !== -1) {
          this.paymentMethodsItems.splice(idx, 1);
        }
        this.deleteDialog = false;
      }
      if (this.deleteMode == "panel") {
        this.deletePanel();
      }
    },
    deletePanel() {
      // delete api
      this.loading = true;
      const id = this.items[this.selectedIndex].id;
      if (id != null) {
        var app = this;
        app.$axios
          .delete(this.$apipoint + `config/destroy/${id}`)
          .then((r) => {
            if (r.data.status == "success") {
              this.loading = false;
              this.items.splice(this.selectedIndex, 1);
              this.deleteDialog = false;
              this.panelDialog = false;
              this.secondPanelDialog = false;
              this.snakbarText = this.$t("your panel removed successfully");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          });
      } else {
        this.items.splice(this.selectedIndex, 1);
        this.panelDialog = false;
        this.secondPanelDialog = false;
        this.loading = false;
        this.deleteDialog = false;
        this.snakbarText = this.$t("your panel removed successfully");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    resolveDomainPrefix() {
      if (
        this.isUserFocusOnDomain &&
        this.newPanel.additional_data.domain_address.length > 0
      ) {
        this.isUserFocusOnDomain = true;
      }
      if (
        this.isUserFocusOnDomain &&
        this.newPanel.additional_data.domain_address.length == 0
      ) {
        this.isUserFocusOnDomain = false;
      }
    },
    openSyncPermission(item, index) {
      var app = this;
      app.$axios
        .get(this.$endpoint + "integrator/portal/list")
        .then((r) => {
          this.items = r.data;
          this.wantedSyncPanel = this.items.find(
            (obj) =>
              obj.panel_name == item.panel_name && obj.panel_status == item.panel_status
          );
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
      this.productSyncPermission = true;
      this.panelName = item.panel_name;
      this.selectedSyncPanel = index;
    },
    synchronization() {
      // call api
      this.pullingProduct();
      this.productSyncPermission = false;
      this.productSync = true;

      if (!this.syncingPanels.includes(this.selectedSyncPanel)) {
        this.syncingPanels.push(this.selectedSyncPanel);
      }
    },
    pullingProduct() {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/" + "portal/pulling-product", {
          panel_token: this.wantedSyncPanel.panel_token,
          url: this.wantedSyncPanel.additional_data.domain_address,
          password: this.wantedSyncPanel.additional_data.password || null,
          contact: this.wantedSyncPanel.additional_data.contact || null,
        })
        .then((r) => {
          if (r.data && r.data.error) {
            this.snakbar = true;
            this.snakbarText = r.data.error;
            this.snakbarColor = "red";
          }
        })
        .catch((error) => {
          const serverError = error.response?.data?.error || "خطای ناشناخته از سمت سرور";
          this.snakbar = true;
          this.snakbarText = serverError;
          this.snakbarColor = "red";
        });
    },
  },
  mounted() {
    this.fetchPanelList();
    this.userInfo = JSON.parse(localStorage.getItem("token"));
  },
  components: {
    MyIcon,
  },
  computed: {
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    invoiceOptions() {
      return [
        { label: this.$t("registration-of-returned-invoice"), value: "register" },
        { label: this.$t("delete-invoice"), value: "delete" },
      ];
    },
    webhookUrl() {
      return `https://integrator.abriron.com/api/portal/webhook?key=${this.newPanel.panel_token}`;
    },
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val?.init) {
          this.newPanel.abr_name = val.init.abrName || null;
          this.newPanel.abr_token = val.token || null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.headers = [
      {
        text: this.$t("bank-or-fund"),
        align: "start",
        sortable: false,
        value: "bank",
        width: "40%",
      },
      {
        text: this.$t("payment-method"),
        align: "start",
        sortable: false,
        value: "method",
        width: "40%",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
        width: "10%",
      },
    ];
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #fcfcfc;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
::v-deep .v-data-table.paymentTable .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.paymentTable {
  border: 1px solid silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  /* background-color: #eeeeee; */
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
  border-left: 1px solid silver;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
.domain-input.v-text-field ::v-deep .v-label.v-label--active {
  right: 0px !important;
}
::v-deep .v-input__prepend-inner {
  position: absolute;
  left: 9px;
  direction: ltr;
}
.domain-input.v-text-field
  ::v-deep
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input {
  margin-left: 48px;
}
</style>
